import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=5f668f47&scoped=true&lang=pug"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"
import style0 from "./Doc.scss?vue&type=style&index=0&id=5f668f47&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f668f47",
  null
  
)

export default component.exports